import { IAddressSearch } from '~interfaces/IStoresInterfaces';
import { StoresMap } from '~domain/entities/StoresMap';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/StoresService';
import { StoresRepository } from '~repositories/StoresRepository';
import { emit, events } from '@estee/elc-service-bus';
import { awaitMapThenFitBoundsOrPan } from '../../utils/MapUtils';
import {
    IFetchDataStrategy,
    StoreLocatorFetchDataStrategy
} from '../strategies/StoresFetchDataStrategies';

export class AddressSelectedUseCase {
    private address: IAddressSearch;
    private storesMap: StoresMap;
    private storesRepository: StoresRepository;
    private fetchDataStrategy: IFetchDataStrategy;

    constructor(
        address: IAddressSearch,
        fetchDataStrategy: IFetchDataStrategy = new StoreLocatorFetchDataStrategy()
    ) {
        this.address = address;
        this.fetchDataStrategy = fetchDataStrategy;
        this.storesMap = diContainer.get(serviceNames.storesMap);
        this.storesRepository = diContainer.get(serviceNames.storesRepository);
    }

    public execute = async () => {
        const searchLocation = { lat: this.address.lat, lng: this.address.lng };
        const fullAddress = this.address.fullValue;
        emit(events.SEARCH_ADDRESS_SUBMITTED, { address: fullAddress });

        await this.fetchDataStrategy.loadStores(searchLocation);

        awaitMapThenFitBoundsOrPan(
            this.storesMap.map,
            this.storesRepository.stores.length,
            searchLocation
        );

        this.storesMap.updateMapCenter({
            lat: String(searchLocation.lat),
            lng: String(searchLocation.lng)
        });
    };
}
